import { ARCANA_SLUG, MATRIX_ARCANA } from '@/api/consts'
import { Text } from '@/app/components/Text/Text'
import { UI } from '@/app/components/UI/UI'
import type { FunctionalComponent } from 'preact'
import styles from './index.module.scss'

const matrixArcanaItems = Object.entries(MATRIX_ARCANA)
  .map(([id, arcana]) => ({
    id: Number(id),
    ...arcana,
  }))
  .sort((a, b) => a.id - b.id)

const matrixArcanaMiddle = Math.ceil(matrixArcanaItems.length / 2)

const matrixArcanaRows = matrixArcanaItems
  .slice(0, matrixArcanaMiddle)
  .map((arcana, index) => [arcana, matrixArcanaItems[index + matrixArcanaMiddle]] as const)

export const ArcanasTable: FunctionalComponent<{
  getLink: (page: string) => string
}> = props => {
  return (
    <div class={styles.root}>
      <UI.Panel class={styles.table}>
        {matrixArcanaRows.map(row => (
          <div class={styles.row} key={row[0].id}>
            {row.map(arcana =>
              arcana && (
                <div class={styles.cell} key={arcana.id}>
                  <UI.Panel
                    hover
                    type='ghost'
                    class='ghost-link'
                    link={props.getLink(`${arcana.id}-${ARCANA_SLUG[arcana.id]}`)}
                  >
                    <Text
                      fontSize={16}
                      fontSizeMobile={14}
                    >
                      <span class='thin-link'>
                        {arcana.id}. {arcana.name}
                      </span>
                    </Text>
                  </UI.Panel>
                </div>
              )
            )}
          </div>
        ))}
      </UI.Panel>
    </div>
  )
}
